export default "__VITE_ASSET__B1dM7ax7__"